import { useState } from 'react';

import { useRouter } from 'next/router';

/**
 * State that resets to `defaultState` whenever the route changes. The reset
 * happens DURING render (React's "adjust state on prop change" pattern), not
 * in an effect: an effect left the previous route's state in place for the
 * first render of the new page, and anything that captured it then (the
 * video editor's moment list) kept the wrong section's data for good.
 */
function useRouteState<T>(
  defaultState: T
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const { asPath } = useRouter();
  const [state, setState] = useState(defaultState);
  const [path, setPath] = useState(asPath);

  if (path !== asPath) {
    setPath(asPath);
    setState(defaultState);
  }

  return [state, setState];
}

export default useRouteState;
